// extracted by mini-css-extract-plugin
export default {"primary-nav-width":"56px","secondary-nav-width":"256px","routeContainer":"styles_routeContainer__r-nDx"};